var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-table',{attrs:{"tableData":_vm.tableData,"tableLabel":_vm.tableLabel,"tableOption":_vm.tableOption,"pager":_vm.pager},on:{"pagination":_vm.loadTable,"handleButton":function($event){return _vm.tableBtnHandle(arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }